import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { pubApi, setPublisherToken } from '../../api/publisherClient';
import PublisherAuthLayout from './PublisherAuthLayout';
import Seo from '../../components/Seo';
import Icon from '../../components/Icon';

export default function PublisherLogin() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const data = await pubApi.login({ email, password });
      setPublisherToken(data.token);
      navigate('/yayinci/panel', { replace: true });
    } catch (err) {
      setError(t([`publisher.err_${err.code}`, 'auth.err_generic']));
    } finally {
      setBusy(false);
    }
  };

  return (
    <PublisherAuthLayout>
      <Seo title="Yayıncı Girişi" noindex />
      <div className="auth-head">
        <h1>{t('publisher.login_title')}</h1>
        <p className="sub">{t('publisher.login_sub')}</p>
      </div>

      {error && (
        <div className="form-error">
          <Icon name="alert-triangle" size={15} style={{ marginTop: 1, flexShrink: 0 }} />
          {error}
        </div>
      )}

      <form onSubmit={submit} noValidate>
        <div className="field">
          <label htmlFor="email">{t('common.email')}</label>
          <div className="control">
            <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
          </div>
        </div>
        <div className="field">
          <label htmlFor="password">{t('common.password')}</label>
          <div className="control">
            <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" placeholder="••••••••" />
          </div>
        </div>
        <button className="btn btn-block" disabled={busy}>
          {busy ? `${t('common.loading')}…` : t('publisher.login_action')}
        </button>
      </form>

      <div className="auth-alt">
        {t('publisher.no_account')} <Link to="/yayinci/kayit">{t('publisher.register_action')}</Link>
      </div>
    </PublisherAuthLayout>
  );
}
